const headers = {
  name: "Reports",
  navigate: {
    tabs: [
      {
        name: "Reports",
        path: "",
      }
    ],
  }
};

export default headers;